export const nav = {
    permissao: "lpbuilder.versoes:visualizar",
    section: "LPBuilder",
    title: "Versoes",
    icon: "history",
    route: "/versoes",
    sequence: 5,
};
export default [
    {
        path: "/versoes",
        name: "lpbuilder-visao-versoes",
        component: () => import("./pages/VisaoVersoesPage.vue"),
        meta: { requiresAuth: true, permissao: "lpbuilder.versoes:visualizar" },
    },
    {
        path: "/projetos/:projetoUuid/versoes",
        name: "lpbuilder-versoes",
        component: () => import("./pages/VersoesPage.vue"),
        props: true,
        meta: { requiresAuth: true, permissao: "lpbuilder.versoes:visualizar" },
    },
];
